import {
  IPB_INVOICE_LIST,
  IPB_INVOICE_LIST_ERROR,
  CLEAN_IPB_INVOICE_LIST,
  CLEAN_IPB_INVOICE_LIST_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function ipbInvoiceListReducer(state = initialState, action) {
  switch (action.type) {
    case IPB_INVOICE_LIST:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case IPB_INVOICE_LIST_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_IPB_INVOICE_LIST:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_IPB_INVOICE_LIST_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
